import { render } from "./ProviderForm.vue?vue&type=template&id=6acc8e81&ts=true"
import script from "./ProviderForm.vue?vue&type=script&lang=ts"
export * from "./ProviderForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__